function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/*=============================================================================
 * Copyright (C) 2017 Stephen F. Norledge and Alces Software Ltd.
 *
 * This file is part of Flight Launch.
 *
 * All rights reserved, see LICENSE.txt.
 *===========================================================================*/


import React from 'react';
import styled from 'styled-components';
import { transparentize } from 'polished';
var defaultProps = {
  onText: 'YES',
  offText: 'NO',
  width: '7rem'
};

function getId(id, name) {
  if (id != null && id !== '') {
    return id;
  }

  if (name != null && name !== '') {
    return name;
  }

  return undefined;
}

var brandSuccess = '#18BC9C';
export var Label = styled.label.withConfig({
  displayName: "SwitchButton__Label",
  componentId: "m3pii1-0"
})(["display:block;overflow:hidden;cursor:pointer;border:2px solid #FFFFF0;border-radius:5px;"]);
var TextWrapper = styled.span.withConfig({
  displayName: "SwitchButton__TextWrapper",
  componentId: "m3pii1-1"
})(["display:block;width:200%;margin-left:-100%;transition:margin 0.3s ease-in 0s;"]);
var Switch = styled.span.withConfig({
  displayName: "SwitchButton__Switch",
  componentId: "m3pii1-2"
})(["display:block;width:1.75rem;margin:0.5rem;background:white;border:0.125rem solid #FFFFF0;border-radius:5px;position:absolute;top:0;bottom:0.125rem;right:calc(", " - 2.75rem);transition:all 0.3s ease-in 0s;"], function (props) {
  return props.width;
});
var Text = styled.span.withConfig({
  displayName: "SwitchButton__Text",
  componentId: "m3pii1-3"
})(["display:block;float:left;width:50%;padding:0;font-size:1.25rem;color:white;font-weight:bold;box-sizing:border-box;"]);
var OnText = styled(Text).withConfig({
  displayName: "SwitchButton__OnText",
  componentId: "m3pii1-4"
})(["padding-left:1.3125rem;background-color:", ";color:white;"], brandSuccess);
var OffText = styled(Text).withConfig({
  displayName: "SwitchButton__OffText",
  componentId: "m3pii1-5"
})(["padding-right:1.3125rem;background-color:#EEEEEE;color:#999999;text-align:right;"]);
var Checkbox = styled.input.withConfig({
  displayName: "SwitchButton__Checkbox",
  componentId: "m3pii1-6"
})(["display:none !important;&:checked + ", "{& ", "{margin-left:0;}& ", "{right:0;}}&:disabled + ", "{cursor:wait;& ", "{background-color:", ";color:", ";}& ", "{background-color:", ";}}"], Label, TextWrapper, Switch, Label, OffText, transparentize(0.5, '#EEEEEE'), transparentize(0.5, '#999999'), OnText, transparentize(0.5, brandSuccess));
var SwitchButton = styled(function (_ref) {
  var className = _ref.className,
      id = _ref.id,
      input = _ref.input,
      name = _ref.name,
      onText = _ref.onText,
      offText = _ref.offText,
      width = _ref.width;
  var calculatedId = getId(id, name);
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(Checkbox, _extends({
    type: "checkbox"
  }, input, {
    id: calculatedId
  })), /*#__PURE__*/React.createElement(Label, {
    htmlFor: calculatedId
  }, /*#__PURE__*/React.createElement(TextWrapper, null, /*#__PURE__*/React.createElement(OnText, null, onText), /*#__PURE__*/React.createElement(OffText, null, offText)), /*#__PURE__*/React.createElement(Switch, {
    width: width
  })));
}).withConfig({
  displayName: "SwitchButton",
  componentId: "m3pii1-7"
})(["position:relative;max-width:", ";user-select:none;"], function (props) {
  return props.width;
});
SwitchButton.defaultProps = defaultProps;
export default SwitchButton;